<script lang="ts">
	import { format } from 'svelte-i18n';
	// Stores
	import { devicesFiltersInitialState } from 'src/stores/ui/filters';
	import type { FilterOption } from 'src/stores/ui/filters';
	// Design system components
	import { Token } from '@Shelly/shelly-design-system';
	import { deepCopy } from 'src/helpers/utilities';

	export let appliedFilters;
	export let toggleFilterOptions;

	let filterOptions: FilterOption[] = [
		{
			id: 'rangeExtender',
			title: $format('filter_range_extenders', {
				default: 'Range extenders',
			}),
			translationDefault: 'Range extenders',
			selected: false,
		},
		{
			id: 'activeRangeExtender',
			title: $format('filter_active_range_extenders', {
				default: 'Active range extenders',
			}),
			translationDefault: 'Active range extenders',
			selected: false,
		},
		{
			id: 'bluetoothDevices',
			title: $format('filter_bluetooth_devices', {
				default: 'Bluetooth devices',
			}),
			translationDefault: 'Bluetooth devices',
			selected: false,
		},
		{
			id: 'bluetoothGateways',
			title: $format('filter_bluetooth_gateways', {
				default: 'Bluetooth gateways',
			}),
			translationDefault: 'Bluetooth gateways',
			selected: false,
		},
		{
			id: 'activeBluetoothGateways',
			title: $format('filter_active_bluetooth_gateways', {
				default: 'Active bluetooth gateways',
			}),
			translationDefault: 'Active bluetooth gateways',
			selected: false,
		},
		{
			id: 'activatedAIModel',
			title: $format('filter_active_ai_models', {
				default: 'Active AI models',
			}),
			translationDefault: 'Active AI models',
			selected: false,
		},
		{
			id: 'virtualDevices',
			title: $format('filter_virtual_devices', {
				default: 'Virtual Devices',
			}),
			translationDefault: 'Virtual Devices',
			selected: false,
		},
		{
			id: 'peripheralDevices',
			title: $format('filter_peripheral_devices', {
				default: 'Peripheral Devices',
			}),
			translationDefault: 'Peripheral Devices',
			selected: false,
		},
		{
			id: 'activeAccessPoint',
			title: $format('filter_active_access_point', {
				default: 'Active access point',
			}),
			translationDefault: 'Active access point',
			selected: false,
		},
	].map((option) => {
		const storeOption = appliedFilters.more_filters.find((filter) => filter.id === option.id);
		option.selected = storeOption?.selected;
		return option;
	});

	const handleSelectFilter = (option) => {
		appliedFilters.more_filters = appliedFilters.more_filters.map((filter) => {
			if (filter.id === option.id) {
				filter.selected = !filter.selected;
				return filter;
			}
			return filter;
		});

		filterOptions = toggleFilterOptions(filterOptions, option);
	};

	const resetData = () => {
		appliedFilters.more_filters = deepCopy(devicesFiltersInitialState.more_filters);

		filterOptions = filterOptions.map((filter) => {
			return {
				...filter,
				selected: false,
			};
		});
	};
</script>

<svelte:window on:reset={resetData} />

<div class="d-flex flex-wrap" style="gap: 8px;">
	{#each filterOptions as option}
		<Token
			id="token-0d9p81s"
			size="m"
			title={option.title}
			on:click={() => handleSelectFilter(option)}
			selected={option.selected}
		/>
	{/each}
</div>
